var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurkish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44939_319328)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44939_319328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34-.192H-3V24h37V-.192z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.646 16.742c-2.726 0-4.934-2.165-4.934-4.838s2.208-4.839 4.934-4.839c1.458 0 2.769.62 3.672 1.61a6.188 6.188 0 00-5.214-2.82c-3.407 0-6.166 2.707-6.166 6.049 0 3.341 2.76 6.048 6.166 6.048a6.192 6.192 0 005.214-2.819 4.957 4.957 0 01-3.672 1.61z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.246 11.904l1.317-1.778-2.131.68-1.317-1.778v2.195l-2.13.68 2.13.681v2.196l1.317-1.778 2.13.68-1.316-1.778z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44939_319328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44939_319328"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-3 -.192)",
    d: "M0 0h37v24.192H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkish);
export default __webpack_public_path__ + "static/media/turkish.033cab3d51f97acbc9d1bc05ec9711b0.svg";
export { ForwardRef as ReactComponent };